module.exports = __webpack_public_path__ + "img/Zoom-in.45c1174e.svg";